import React, { Component } from 'react';
import CustomInput from '../../../Utility/Components/CustomInput';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse } from '../../../../Actions/AllAction';
import { setToken, setUserCredentials, logOutApp } from '../../../Login/Actions/LoginAction';
import * as ProfessionalController from './Controller/ProfessionalController'
import Utility from '../../../Utility/Utility';
import moment from 'moment';
import ErrorBoundary from '../../../Utility/Components/ErrorBoundary';
import AutosuggestComponent from '../../../Utility/Components/AutosuggestComponent';
import { withNamespaces } from 'react-i18next';
import CommonDateTimePicker from '../../../Utility/Components/CommonDateTimePicker';


class Professional extends Component {
	constructor(props) {
		super(props);
		this.state = {
			professionalTabFormData: {
				emp_id: "",
				working_hours: "",
				joining_date: "",
				end_of_contract: "",
				role: ""
			},
			professionalTabFormDataError: {
				emp_id: "",
				working_hours: "",
				joining_date: "",
				end_of_contract: "",
				role: ""
			},
			button_enabled: false,
			userProfessionalId: "",
			userProfessionalData: {},
			roleList: [],
			roleSelectedValue: {},
			professionalDetailsUpdate: false,
			roleDetailsUpdate: false,
		}

	}

	componentDidMount = () => {
		this.userProfessionalInfo();
		this.roleListGetApi()
	}

	//get user professional info api
	userProfessionalInfo = () => {
		const { loaderStateTrue, loaderStateFalse, userProfileId } = this.props;
		loaderStateTrue();
		ProfessionalController.userProfessionalInfoGet(userProfileId).then((response) => {
			if (response.success) {
				this.setState({
					userProfessionalId: response.data[0].hasOwnProperty('UserProfInfo') ? response.data[0].UserProfInfo.id : "",
					userProfessionalData: response.data[0].hasOwnProperty('UserProfInfo') ? response.data[0].UserProfInfo : {},
				}, () => {
					this.setUserProfessionalInfoData()
				})
			}
			loaderStateFalse();
		}).catch((error) => {
			console.error("************error*************", error)
			if (error) {
			}
			loaderStateFalse();
		});
	}

	//professional information update fn
	professionalfromSubmitData = () => {
		if (this.state.professionalDetailsUpdate) {
			this.updateProfessionalDetails()
		}
		if (this.state.roleDetailsUpdate) {
			this.updateRoleDetails()
		}


	}

	//update user professional information api fn
	updateProfessionalDetails = () => {
		let valid = this.validationFromData();
		const { loaderStateTrue, loaderStateFalse } = this.props;
		let data = this.formatingDataset();
		data = data[0];
		let type = 'patch'
		loaderStateTrue();
		ProfessionalController.updateProfessionalDetailsUpdate(data, type, this.state.userProfessionalId).then((response) => {
			loaderStateFalse();
			if (response) {
				if (response.success) {
					// this.props.detectChangesIndividualTab(false)
					// this.props.detectChangesIndividualInnerTab(false)
					this.userProfessionalInfo()
					this.setState({
						button_enabled: false,
						professionalDetailsUpdate: false
					}, () => {
					})
					Utility.toastNotifications(response.message, "Success", "success");
				} else {
					Utility.toastNotifications(response.message, "Error", "error")
				}
			}

		}).catch((error) => {
			console.error("************error*************", error)
			if (error) {
			}
			loaderStateFalse();
			if (error.message == "Network Error") {

			}
		});
	}

	//update role details api fn
	updateRoleDetails = () => {
		const { loaderStateTrue, loaderStateFalse, userProfileId } = this.props;
		let data = this.roleFormatingDataset();
		data = data[0];
		let type = 'patch'
		loaderStateTrue();
		ProfessionalController.roleDataUpdate(data, type, userProfileId).then((response) => {
			loaderStateFalse();
			if (response) {
				if (response.success) {
					// this.props.detectChangesIndividualTab(false)
					// this.props.detectChangesIndividualInnerTab(false)
					this.userProfessionalInfo()
					this.setState({
						button_enabled: false,
						roleDetailsUpdate: false
					}, () => {
					})
					Utility.toastNotifications(response.message, "Success", "success");
				} else {
					Utility.toastNotifications(response.message, "Error", "error")
				}
			}

		}).catch((error) => {
			console.error("************error*************", error)
			if (error) {
			}
			loaderStateFalse();
			if (error.message == "Network Error") {

			}
		});
	}

	//professional tab changes cancell fn
	cancelChangesProfessionalTab = () => {
		// this.props.detectChangesIndividualTab(false)
		// this.props.detectChangesIndividualInnerTab(false)
		this.setState({
			button_enabled: false,
			professionalDetailsUpdate: false,
			roleDetailsUpdate: false
		}, () => { })
	}


	//professional tab input field handle change fn
	handelChange = (e, type) => {
		// this.props.detectChangesIndividualTab(true)
		// this.props.detectChangesIndividualInnerTab(true)
		const { professionalTabFormData, professionalTabFormDataError } = this.state;
		let tempFormData = Object.assign(professionalTabFormData);
		let tempErrorFormData = Object.assign(professionalTabFormDataError)

		if (type == "emp_id") {
			var expr = /^[a-zA-Z0-9 -]*$/;
			if (!expr.test(e.target.value)) {

			} else {
				if (e.target.value == "") {
					tempErrorFormData['emp_id'] = ""
					tempFormData["emp_id"] = ""
				} else {
					tempFormData["emp_id"] = e.target.value
					tempErrorFormData['emp_id'] = ""
				}
			}
		}

		if (type == "working_hours") {
			var expr = /^[0-9]*$/;
			if (!expr.test(e.target.value)) {

			} else {
				if (e.target.value == "") {
					tempErrorFormData['working_hours'] = ""
					tempFormData["working_hours"] = ""
				} else {
					tempFormData["working_hours"] = e.target.value
					tempErrorFormData['working_hours'] = ""
				}
			}
		}

		if (type == "joining_date") {
			if (e == "") {
				tempErrorFormData['joining_date'] = ""
				tempFormData["joining_date"] = ""
			} else {
				tempFormData["joining_date"] = e
				tempErrorFormData['joining_date'] = ""
				tempErrorFormData['end_of_contract'] = ""
				tempFormData["end_of_contract"] = ""

			}
		}

		if (type == "end_of_contract") {
			if (e == "") {
				tempErrorFormData['end_of_contract'] = ""
				tempFormData["end_of_contract"] = ""
			} else {
				tempFormData["end_of_contract"] = e
				tempErrorFormData['end_of_contract'] = ""
			}
		}

		this.setState({
			professionalTabFormData: tempFormData,
			professionalTabFormDataError: tempErrorFormData,
			button_enabled: true,
			professionalDetailsUpdate: true,
		})
	}

	//role input field handle change fn 
	roleHandelChange = (e, type) => {
		// this.props.detectChangesIndividualTab(true)
		// this.props.detectChangesIndividualInnerTab(true)
		const { professionalTabFormData, professionalTabFormDataError } = this.state;
		let tempFormData = Object.assign(professionalTabFormData);
		let tempErrorFormData = Object.assign(professionalTabFormDataError)

		if (type == 'role') {
			if (e) {
				tempFormData["role"] = e;
				tempErrorFormData['role'] = "";
				this.setState({
					roleSelectedValue: e
				})
			} else {
				tempFormData["role"] = "";
				tempErrorFormData['role'] = "Required Field";
				this.setState({
					roleSelectedValue: {}
				})

			}
		}
		this.setState({
			professionalTabFormData: tempFormData,
			professionalTabFormDataError: tempErrorFormData,
			button_enabled: true,
			roleDetailsUpdate: true,
		})
	}

	//professional tab validation fn
	validationFromData = () => {
		const { professionalTabFormData, professionalTabFormDataError } = this.state;
		let tempFormData = Object.assign(professionalTabFormData);
		let tempErrorFormData = Object.assign(professionalTabFormDataError)

		let valid = true

		this.setState({
			professionalTabFormDataError: tempErrorFormData
		})
		return valid
	}

	//professional tab update dataset create fn
	formatingDataset = () => {
		const { professionalTabFormData } = this.state
		let dataset = [];
		let hash = {}

		if (professionalTabFormData.emp_id != "" && professionalTabFormData.emp_id != null) {
			hash['emp_number'] = professionalTabFormData.emp_id;
		} else {
			hash['emp_number'] = "";
		}

		if (professionalTabFormData.working_hours != "" && professionalTabFormData.working_hours != null) {
			hash['working_hours'] = professionalTabFormData.working_hours;
		} else {
			hash['working_hours'] = "";
		}

		if (professionalTabFormData.joining_date != "" && professionalTabFormData.joining_date != null) {
			hash['joining_date'] = moment(professionalTabFormData.joining_date.toString()).format('YYYY-MM-DD');
		} else {
			hash['joining_date'] = "";
		}

		if (professionalTabFormData.end_of_contract != "" && professionalTabFormData.end_of_contract != null) {
			hash['end_of_contract'] = moment(professionalTabFormData.end_of_contract.toString()).format('YYYY-MM-DD');
		} else {
			hash['end_of_contract'] = "";
		}

		hash['user_id'] = this.props.userProfileId;

		dataset.push(hash)
		return dataset;

	}

	//role update api dataset create fn 
	roleFormatingDataset = () => {
		const { professionalTabFormData } = this.state
		let dataset = [];
		let hash = {}

		if (professionalTabFormData.role.value != "" && professionalTabFormData.role.value != null) {
			hash['role_id'] = professionalTabFormData.role.value;
		}

		dataset.push(hash)
		return dataset;
	}

	//set professional information after getting the details
	setUserProfessionalInfoData = () => {
		const { userProfessionalData } = this.state
		if (Object.keys(userProfessionalData).length > 0) {
			let joiningDate = ""
			if (userProfessionalData.joining_date == null || userProfessionalData.joining_date == "") {
				joiningDate = "";
			} else {
				joiningDate = new Date(userProfessionalData.joining_date);
			}
			let endOfContract = ""
			if (userProfessionalData.end_of_contract == null || userProfessionalData.end_of_contract == "") {
				endOfContract = "";
			} else {
				endOfContract = new Date(userProfessionalData.end_of_contract);
			}
			let roleUserRelationDetails = userProfessionalData.UserProfInfoOrgBranchRoleRelation?.RoleUserRelation
			this.setState({
				professionalTabFormData: {
					emp_id: userProfessionalData.emp_number,
					working_hours: userProfessionalData.working_hours,
					joining_date: joiningDate,
					end_of_contract: endOfContract,
					role: { label: roleUserRelationDetails.name, value: roleUserRelationDetails.id }
				},
				roleSelectedValue: { label: roleUserRelationDetails.name, value: roleUserRelationDetails.id }
			})
		}
	}

	roleListGetApi = () => {
		const { loaderStateTrue, loaderStateFalse, selectedRowsData } = this.props;
		let branchId = selectedRowsData.hasOwnProperty('UserOrgBranchRoleRelation') && selectedRowsData.UserOrgBranchRoleRelation.length > 0 && selectedRowsData.UserOrgBranchRoleRelation[0].branch_id
		let data = {};
		let globalQueryParamshash = {};
		globalQueryParamshash["is_active"] = 1;
		globalQueryParamshash["branch_id"] = branchId;
		data['filters'] = JSON.stringify(globalQueryParamshash)
		loaderStateTrue();
		ProfessionalController.roleListGet(data).then((response) => {
			let roleListData = [];
			let roleListObj = {};
			if (response.data.length > 0) {
				response.data.map((value, idx) => {
					roleListObj = {};
					roleListObj['label'] = value.name;
					roleListObj['value'] = value.id;
					roleListData.push(roleListObj)
				})
			}
			this.setState({
				roleList: roleListData
			})
			loaderStateFalse();
		}).catch((error) => {
			loaderStateFalse();

		});
	}


	render() {
		const { professionalTabFormData, professionalTabFormDataError } = this.state;
		let rolePermission = Object.keys(Utility.getRoleObjectByEventKey('user_profile')).length > 0 && (Utility.getRoleObjectByEventKey('user_profile').subeventKey.length > 0 && Utility.getRoleObjectByEventKey('user_profile').subeventKey[1].eventKey == "professional" && (Utility.getRoleObjectByEventKey('user_profile').subeventKey[1].rules == "CRUD" || Utility.getRoleObjectByEventKey('user_profile').subeventKey[1].rules == "CUD"))
		console.log("rolePermission===========",rolePermission, this.state.button_enabled)
		return (
			<div className="profilecontainer profilepersonalconBox userWrite general_profilepersonalcon_box">
				<div className="inputviewinner">
					<div className="jbssadn_en_ndassbj">
						<div className={professionalTabFormDataError.emp_id != "" ? "inputrowbox showerror" : "inputrowbox"}>
							<div className="inputlabelview">Emp Number</div>
							<div className="inputfieldview">
								<ErrorBoundary title="CustomInput Error">
									<CustomInput
										parentClassName="input_field_inner"
										type="text"
										value={professionalTabFormData.emp_id}
										onChange={(e) => this.handelChange(e, 'emp_id')}
									/>
								</ErrorBoundary>
							</div>
						</div>

						<div className={professionalTabFormDataError.working_hours != "" ? "inputrowbox showerror" : "inputrowbox"}>
							<div className="inputlabelview">Working Hours</div>
							<div className="inputfieldview">
								<ErrorBoundary title="CustomInput Error">
									<CustomInput
										parentClassName="input_field_inner"
										type="text"
										value={professionalTabFormData.working_hours}
										onChange={(e) => this.handelChange(e, 'working_hours')}
									/>
								</ErrorBoundary>
							</div>
						</div>
						<div className={professionalTabFormDataError.joining_date != "" ? "inputrowbox showerror" : "inputrowbox"}>
							<div className="inputlabelview">Joining Date</div>
							<div className="inputfieldview datepickerrow">
								<ErrorBoundary title="CustomInput Error">
									<CommonDateTimePicker
										selected={professionalTabFormData.joining_date}
										onChange={(e) => this.handelChange(e, 'joining_date')}
										showTimeSelect={false}
										dateFormat="dd-MM-yyyy"
										placeholderText="Select date"
										minDate=""
										maxDate={new Date()}
									/>
								</ErrorBoundary>
							</div>
						</div>
						<div className={professionalTabFormDataError.role != "" ? "inputrowbox showerror" : "inputrowbox"}>
							<div className="inputlabelview">Role</div>
							<div className="inputfieldview profiledropdownBox">
								<ErrorBoundary title="CustomInput Error">
									<AutosuggestComponent
										handleOnChange={(e) => this.roleHandelChange(e, 'role')}
										options={this.state.roleList}
										selectedValue={this.state.roleSelectedValue}
										name=''
										isMulti={false}
										placeholder=""
										isSearchable={true}
										classNamePrefix="dropdown-default"
									/>
								</ErrorBoundary>
							</div>
						</div>

					</div>
				</div>
				<div className="rightsideview">
					{this.state.button_enabled && rolePermission &&
						<button type="button" className="submitbtnprofileContainer" onClick={this.professionalfromSubmitData}>Submit</button>
					}
				</div>
			</div>
		);
	}
}

const mapStateToProps = (globalState) => {
	return {
		userCredentials: globalState.LoginReducer.userCredentials,
		roleWisePermission: globalState.mainReducerData.roleWisePermission

	};
}

export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, setToken, setUserCredentials, logOutApp })
	(withNamespaces()(Professional));